// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"8aa109ea","781":"338b555f","976":"a60fc9a8"}[chunkId] + ".chunk.js";
};